// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".post-date-publish {\n  display: flex;\n  margin-top: 15px;\n  margin-bottom: 20px;\n}\n.post-date-input {\n  max-width: 130px;\n}\n.post-time-input {\n  max-width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
